import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'motion/react';
import { Sidebar } from './Sidebar';
import { HOME_PATH_BY_ROLE, isPathAllowedForRole, type HawkRole } from '../rolePaths';

export type { HawkRole };

interface MainLayoutProps {
  currentRole: HawkRole;
}

export function MainLayout({ currentRole }: MainLayoutProps) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const path = location.pathname;
    if (path !== '/' && !isPathAllowedForRole(path, currentRole)) {
      navigate(HOME_PATH_BY_ROLE[currentRole], { replace: true });
    }
  }, [currentRole, location.pathname, navigate]);

  return (
    <div className="min-h-screen bg-[rgb(224_231_255/0.6)] flex h-screen overflow-hidden">
      <Sidebar currentRole={currentRole} />
      <main className="min-w-0 max-w-full flex-1 min-h-0 flex flex-col overflow-hidden p-1 sm:p-2 sm:pl-3 md:pl-4">
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
          className="hawk-content-shell flex min-h-0 flex-1 flex-col overflow-hidden rounded-2xl"
        >
          <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-xl">
            <Outlet />
          </div>
        </motion.div>
      </main>
    </div>
  );
}
